import React from 'react';

const QuickBookIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1721_23573)'>
        <path
          d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z'
          fill='#2CA01C'
        />
        <path
          d='M2.41039 9.99758C2.41119 12.2584 4.23439 14.0968 6.49519 14.1168H7.07359V12.6056H6.49519C5.09359 12.988 3.64799 12.1616 3.26639 10.76C3.26319 10.7488 3.26079 10.7376 3.25759 10.7264C2.86479 9.30638 3.68719 7.83518 5.10239 7.42638H5.39119C5.75359 7.34718 6.12879 7.34718 6.49119 7.42638H7.89599V15.4496C7.88879 16.2984 8.57119 16.9928 9.41999 17.0008V5.83758H6.50399C4.22719 5.84958 2.39199 7.70478 2.40399 9.98158V9.98238L2.41039 9.99758ZM13.5104 5.83918H12.932V7.43038H13.5104C14.9088 7.04878 16.3512 7.87278 16.7328 9.27038C16.736 9.28078 16.7384 9.29198 16.7416 9.30238C17.132 10.7176 16.312 12.1832 14.9024 12.5912H14.6136C14.2512 12.6704 13.876 12.6704 13.5136 12.5912H12.1088V4.56878C12.116 3.71998 11.4336 3.02558 10.5848 3.01758V14.1968H13.5008C15.7976 14.1608 17.6304 12.2704 17.5952 9.97358C17.56 7.72718 15.748 5.91438 13.5008 5.87918L13.5104 5.83918Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1721_23573'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuickBookIcon;
